import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<React.StrictMode data-id="element-325">
      <App data-id="element-326" />
    </React.StrictMode>);
}